
export const FETCH_UNIVER_UI = 'FETCH_UNIVER_UI'
export const FETCH_MAIN_DATA = 'FETCH_MAIN_DATA'
export const FETCH_LIST_DATA = 'FETCH_LIST_DATA'

export const UUI_GLOBAL = 'UUI_GLOBAL'
export const UUI_THEME = 'UUI_THEME'

export const GET_MAIN_DATA = 'GET_MAIN_DATA'
export const GET_LIST_DATA = 'GET_LIST_DATA'
export const GET_MAIN_ACCESS = 'GET_MAIN_ACCESS'
export const GET_USER_SAMNAME = 'GET_USER_SAMNAME'
export const GET_USER_CULTURE = 'GET_USER_CULTURE'
export const CLEAR_LIST_DATA = 'CLEAR_LIST_DATA'
export const SET_LOADING = 'SET_LOADING'

export const SHOW_MESS_APP = 'SHOW_MESS_APP'
export const SHOW_ALERT_APP = 'SHOW_ALERT_APP'
export const SHOW_DIALOG_APP = 'SHOW_DIALOG_APP'
export const DIALOG_ANSWER = 'DIALOG_ANSWER'

export const SEND_UPDATES_SUCCESS = 'SEND_UPDATES_SUCCESS'
export const SEND_UPDATES_FAILURE = 'SEND_UPDATES_FAILURE'
